import { IUsersControls } from "../utility/admin/UsersControls/IUsersControls";
import { IAdminApi, AdminApi } from "../utility/admin/AdminApi";
import { UsersControls } from "../utility/admin/UsersControls/UsersControls";
import { IServicesProvider } from "./IServicesProvider";
import { Observable } from "rxjs";
import { first, map } from "rxjs/operators";

/**
 * Defines Interface for avialable non-admin which can be provided
 * by an instance of IAdminServicesProvider. 
 * Usually services that aren't BaseAdminOperations.
 */
export interface IAdminServicesProvider {
    getUsersControls(): IUsersControls;
}

/**
 * Implementation for IAdminServicesProvider. Constructor is intentionally private to force 
 * usage of the builder function Build().
 */
export class AdminServicesProvider implements IAdminServicesProvider {
    private usersControls: IUsersControls;
    private adminApi: IAdminApi;
    /**
     * Prepares an observable to recieve an instance of IAdminServicesProvider
     * @param servicesProvider an initialized instance of IServicesProvider
     * @param organisationCode User's organiastion code
     * @returns Observable<IAdminServicesProvider>
     */
    public static Build(
        servicesProvider: IServicesProvider, 
        organisationCode: string
    ): Observable<IAdminServicesProvider> {
        let services = new AdminServicesProvider(servicesProvider, organisationCode);
        return UsersControls.Build(
            servicesProvider.getDataStore(),
            services.adminApi,
            servicesProvider.getOrganisation()
        ).pipe(
            first(),
            map(controls => {
                services.usersControls = controls;
                return services;
            })
        );
    }
    getUsersControls(): IUsersControls {
        return this.usersControls;
    }

    private constructor (servicesProvider: IServicesProvider, organisationCode: string) {
        this.adminApi = new AdminApi( 
            servicesProvider.getHttpClient(),
            servicesProvider.getAuthenticatedHttpClient(), 
            organisationCode );
    }
}


// WEBPACK FOOTER //
// ./src/di/IAdminServicesProvider.ts